import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    await this.auth.ensureReady();
    await firstValueFrom(this.auth.loading$.pipe(filter(loading => !loading)));

    if (!this.auth.currentUser) {
      const isInsights = state.url.startsWith('/insights/');
      this.router.navigate(['/login'], {
        queryParams: isInsights
          ? { context: 'insights', returnUrl: state.url }
          : {}
      });
      return false;
    }

    if (!this.auth.isAdmin) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
